import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibEditIcon } from '@chewy/kib-icons-react'

import '@chewy/kib-fields-new-styles/dist/styles/kib-field.css'
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './AppointmentDetails.module.scss'

export interface AppointmentDetailsProps {
  appointmentTypeName?: string
  assignedVet: string
  editButtonLabel: string
  onEditClick: () => void
  startDate: string
  startTime: string
}

const AppointmentDetails = ({
  appointmentTypeName,
  assignedVet,
  startDate,
  startTime,
  onEditClick,
  editButtonLabel,
}: AppointmentDetailsProps) => (
  <div className={styles.container}>
    <span className={styles.appointmentTypeName}>{appointmentTypeName}: </span>
    <span>
      {assignedVet} • {startDate} at {startTime}
    </span>
    <KibButtonNew
      iconOnly
      aria-label={editButtonLabel}
      emphasis="secondary"
      icon={<KibEditIcon />}
      size="small"
      theme="utility"
      onClick={onEditClick}
    />
  </div>
)

export default AppointmentDetails
